var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTweet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 38,
    height: 38,
    rx: 17,
    fill: "#071E3B",
    fillOpacity: 0.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4577 14.5C28.9577 22 23.4577 28 16.4577 28C14.0458 28 11.6339 27.6768 9.74165 26.7706C9.30827 26.5631 9.47767 25.985 9.95712 25.9532C12.2872 25.7987 14.2154 25.2423 15.4577 24C10.0413 22.1945 9.10701 15.4995 10.08 12.0072C10.1942 11.5971 10.7274 11.595 10.9423 11.9625C12.6037 14.8037 15.7629 16.39 19.7223 16.024C19.551 15.548 19.4577 15.0349 19.4577 14.5C19.4577 12.0147 21.4724 10 23.9577 10C25.4759 10 26.8185 10.7518 27.6335 11.9035L29.3506 11.6581C29.7785 11.597 30.0771 12.0709 29.8374 12.4305L28.4577 14.5Z",
    fill: "#145DA1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTweet);
export default __webpack_public_path__ + "static/media/tweet.b3f47bc535b81a2151136cd5e88db661.svg";
export { ForwardRef as ReactComponent };